import React, { useState } from "react";
import "./ScooterRide.css";
import { Link } from "react-router-dom";
/* ---------------- SCOOTER DATA ---------------- */
import HondaActiva6G from "../../assets/HondaActiva6G.png";
import TVSJupiter from "../../assets/TVSJupiter.png";
import SuzukiAccess125 from "../../assets/SuzukiAccess125.png";
import HeroMaestroEdge from "../../assets/HeroMaestroEdge.png";
import YamahaFascino from "../../assets/YamahaFascino.png";
import HondaDio from "../../assets/HondaDio.png";
import TVSNtorq from "../../assets/TVSNtorq.png";
import HeroPleasure from "../../assets/HeroPleasure.png";
import YamahaRayZR from "../../assets/YamahaRayZR.png";
import SuzukiBurgman from "../../assets/SuzukiBurgman.png";
import HeroDestini from "../../assets/HeroDestini.png";
import TVSScootyPep from "../../assets/TVSScootyPep.png";

import OlaS1 from "../../assets/OlaS1.png";
import Ather450X from "../../assets/Ather450X.png";
import TVSIQube from "../../assets/TVSIQube.png";
import BajajChetakEV from "../../assets/BajajChetakEV.png";

import AmpereMagnus from "../../assets/AmpereMagnus.png";
import BounceInfinity from "../../assets/BounceInfinity.png";
import SimpleOne from "../../assets/SimpleOne.png";
import HeroOptima from "../../assets/HeroOptima.png";
import OkinawaPraise from "../../assets/OkinawaPraise.png";
import PureEVEpluto from "../../assets/PureEVEpluto.png";
import LectrixEV from "../../assets/LectrixEV.png";
const scooterData = [
  {
    id: 1,
    name: "Honda Activa 6G",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Scooter",
    price: 180,
    image: HondaActiva6G,
  },
  {
    id: 2,
    name: "TVS Jupiter",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Scooter",
    price: 175,
    image: TVSJupiter,
  },
  {
    id: 3,
    name: "Suzuki Access 125",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Scooter",
    price: 185,
    image: SuzukiAccess125,
  },
  {
    id: 4,
    name: "Hero Maestro Edge",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Scooter",
    price: 170,
    image: HeroMaestroEdge,
  },
  {
    id: 5,
    name: "Yamaha Fascino",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Scooter",
    price: 178,
    image: YamahaFascino,
  },
  {
    id: 6,
    name: "Honda Dio",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Scooter",
    price: 172,
    image: HondaDio,
  },
  {
    id: 7,
    name: "TVS Ntorq",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Scooter",
    price: 190,
    image: TVSNtorq,
  },
  {
    id: 8,
    name: "Hero Pleasure",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Scooter",
    price: 165,
    image: HeroPleasure,
  },
  {
    id: 9,
    name: "Yamaha Ray ZR",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Scooter",
    price: 176,
    image: YamahaRayZR,
  },
  {
    id: 10,
    name: "Suzuki Burgman",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Scooter",
    price: 195,
    image: SuzukiBurgman,
  },
  {
    id: 11,
    name: "Hero Destini",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Scooter",
    price: 170,
    image: HeroDestini,
  },
  {
    id: 12,
    name: "TVS Scooty Pep",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Scooter",
    price: 160,
    image: TVSScootyPep,
  },

  {
    id: 13,
    name: "Ola S1",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Scooter",
    price: 190,
    image: OlaS1,
  },
  {
    id: 14,
    name: "Ather 450X",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Scooter",
    price: 100,
    image: Ather450X,
  },
  {
    id: 15,
    name: "TVS iQube",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Scooter",
    price: 185,
    image: TVSIQube,
  },
  {
    id: 16,
    name: "Bajaj Chetak EV",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Scooter",
    price: 195,
    image: BajajChetakEV,
  },

  {
    id: 17,
    name: "Ampere Magnus",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Scooter",
    price: 180,
    image: AmpereMagnus,
  },
  {
    id: 18,
    name: "Bounce Infinity",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Scooter",
    price: 175,
    image: BounceInfinity,
  },
  {
    id: 19,
    name: "Simple One",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Scooter",
    price: 105,
    image: SimpleOne,
  },
  {
    id: 20,
    name: "Hero Optima",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Scooter",
    price: 170,
    image: HeroOptima,
  },
  {
    id: 21,
    name: "Okinawa Praise",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Scooter",
    price: 182,
    image: OkinawaPraise,
  },
  {
    id: 22,
    name: "Pure EV Epluto",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Scooter",
    price: 178,
    image: PureEVEpluto,
  },
  {
    id: 23,
    name: "Lectrix EV",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Scooter",
    price: 176,
    image: LectrixEV,
  },
];

/* ---------------- COMPONENT ---------------- */

const ScooterRide = () => {
  const [type, setType] = useState("Petrol");

  const filteredScooters = scooterData.filter(
    (scooter) => scooter.fuel === type,
  );

  return (
    <div className="scooter-page">
      <div className="scooter-buttons">
        <button className="petrol-btn" onClick={() => setType("Petrol")}>
          Petrol Scooter
        </button>
        <button className="electric-btn" onClick={() => setType("Electric")}>
          Electric Scooter
        </button>
      </div>

      <div className="scooter-grid">
        {filteredScooters.map((scooter) => (
          <Link
            to="/bike-traveller-rental-detail-page"
            className="scooter-ride-link"
            state={{
              carData: scooter,
              totalPrice: scooter.price, // ✅ sending price
            }}
            key={scooter.id}
          >
            {" "}
            <div className="scooter-card" key={scooter.id}>
              <div className="tag-left">{scooter.type}</div>
              <div className="tag-right">₹{scooter.price}</div>

              <div className="scooter-image-div">
                {" "}
                <img src={scooter.image} alt={scooter.name} />
              </div>

              <h3>{scooter.name}</h3>
              <p>{scooter.capacity}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ScooterRide;
